import TodoStateFunc from "@/pcomponents/common/content/todo/state/func/state_func";
import HomeWorkStateSelect from "./homework_state";
import strFunc from "@/lib/lyg/string";

function TodoHomeWorkTd(props: any) {
  let myProps = {
    Style: {},
    info: {},
    is_check_show_textarea: false,
    is_checked_row: false,
    select_date: "",
    pre_date_str: "",
    openTodoDaySort: (inData: any) => { },
    sort: "study",//pre_homework
    subject_name: "",

    daily_info: {},
    onChange: (inData: any) => { },
    select_homework_state_arr: [],
    ...props
  };
  let Style = myProps.Style;
  let info = myProps.info;
  let select_date = myProps.select_date;
  let pre_date_str = myProps.pre_date_str;
  let subject_name = myProps.subject_name;
  let todo_sort = "study";
  let date_sort = "now";
  let daily_key_name = "a_study_state";
  let show_select_date = select_date;
  if (myProps.sort == "pre_homework") {
    todo_sort = "pre_homework";
    date_sort = "pre";
    daily_key_name = "a_homework_state";
    show_select_date = pre_date_str;
  }
  let todo_study_file_cnt = TodoStateFunc.get_file_cnt_by_user_info({
    info: info,
    date_sort: date_sort,//pre,now
    select_date: show_select_date,
    pre_date_str: pre_date_str,
    file_sort: todo_sort,
    subject_name: subject_name
  });

  let todo_per_average = 0;
  let per_average = 0;
  let todo_study_count = 0;
  let todo_homework_count = 0;

  if (info.td_sort_data_json && info.td_sort_data_json[todo_sort]) {
    if (!strFunc.is_empty(subject_name)) {
      if (info.td_sort_data_json[todo_sort]["subject_data_json"][subject_name]) {
        todo_per_average = info.td_sort_data_json[todo_sort]["subject_data_json"][subject_name]["percent"];
        todo_study_count = info.td_sort_data_json[todo_sort]["subject_data_json"][subject_name]["count"];
        todo_study_file_cnt += info.td_sort_data_json[todo_sort]["subject_data_json"][subject_name]["file_cnt"];
      }
    } else {
      todo_per_average = info.td_sort_data_json[todo_sort]["percent"];
      todo_study_count = info.td_sort_data_json[todo_sort]["count"];
      todo_study_file_cnt += info.td_sort_data_json[todo_sort]["file_cnt"];
    }
  }

  let study_color_json = TodoStateFunc.get_color_of_percent(todo_per_average);
  let color_json = TodoStateFunc.get_color_of_percent(per_average);

  let homework_select_style: any = { width: "90%" };
  if (todo_study_count > 0 || todo_study_file_cnt > 0) {
    homework_select_style["width"] = "16px";
  }
  if (myProps.is_check_show_textarea) {
    if (myProps.is_checked_row) {
      if (homework_select_style["width"] == "90%") {
        homework_select_style["minHeight"] = "55px";
      }
    }
  }

  return (
    <div>
      <div className="text-center" style={{minWidth:"60px"}} >
        {todo_study_count > 0 &&
          <span style={{ color: study_color_json.per, cursor: "pointer" }}
            onClick={() => {
              myProps.openTodoDaySort({
                select_stu_name: info["a_user_name"],
                select_stu_seq: info["a_seq"],
                select_date: show_select_date,
                subject_name: subject_name
              });
            }}>
            <span style={{ fontSize: "11px" }} title={todo_study_count + ""}>
              {todo_per_average}%
            </span>
          </span>
        }
        {todo_study_file_cnt > 0 &&
          <span style={{ fontSize: "12px" }}
            onClick={() => {
              myProps.openTodoDaySort({
                select_stu_name: info["a_user_name"],
                select_stu_seq: info["a_seq"],
                select_date: show_select_date,
                subject_name: subject_name
              });
            }}>
            {todo_study_file_cnt}
          </span>
        }
        <span className="ml-1">
          <HomeWorkStateSelect
            daily_info={myProps.daily_info}
            daily_key_name={daily_key_name}
            onChange={myProps.onChange}
            select_homework_state_arr={myProps.select_homework_state_arr}
            select_style={homework_select_style}
          ></HomeWorkStateSelect>
        </span>
      </div>
    </div>
  );
};
export default TodoHomeWorkTd;